export const headerHeight = 67;

export const footerHeight = 51;

export const sideBarWidth = 393;
export const sideBarClosedWidth = 65;

export const layoutMargin = 11;
export const layoutChildrenRadius = 3;

export const modalHorizontalPadding = 18;
